





























import { ContactLensImageType } from '@/store/modules/contactLensImageType'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

/**
 * カラコン商品一覧の画像種別を切り替えるUIコンポーネント
 * クリックするたびに次の種別に循環選択し、ストア経由で商品一覧の画像に反映する
 * @see https://github.com/Everforth/growthpalette-front/issues/8656
 */
@Component
export default class ContactLensImageTypeSwitcher extends Vue {
  readonly options: Array<{ type: ContactLensImageType; label: string }> = [
    { type: 'worn', label: '着画で見る' },
    { type: 'lens', label: 'レンズで見る' },
    { type: 'package', label: 'モデルで見る' },
  ]

  get imageType(): ContactLensImageType {
    return this.$store.state.contactLensImageType.imageType
  }

  get nextOption(): { type: ContactLensImageType; label: string } {
    const currentIndex = this.options.findIndex(o => o.type === this.imageType)
    const safeIndex = currentIndex === -1 ? 0 : currentIndex
    const nextIndex = (safeIndex + 1) % this.options.length

    return this.options[nextIndex]
  }

  next() {
    this.$store.commit('contactLensImageType/setImageType', this.nextOption.type)
  }
}
